import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { COMPANY } from "../lib/siteData";

export default function FloatingButtons() {
  return (
    <>
      <a
        href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent("Hi CNGTPL Solar, I'm interested in a free consultation.")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 group"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-blue-600 animate-pulse-ring" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-blue-600 text-white shadow-2xl shadow-blue-600/30 group-hover:bg-blue-700 transition">
          <MessageCircle className="w-7 h-7" fill="white" strokeWidth={0} />
        </span>
      </a>
      <a
        href={`tel:${COMPANY.phone}`}
        className="fixed bottom-6 left-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-slate-900 text-white shadow-2xl hover:bg-slate-800 transition"
        data-testid="floating-call-btn"
        aria-label="Call us"
      >
        <Phone className="w-6 h-6 text-blue-400" />
      </a>
    </>
  );
}
